import * as api from "../API/index";

export const login = async (loginData) => {
  try {
    const res = await api.user_login(loginData);
    return res.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const logout = async () => {
  try {
    const res = await api.user_logout();
    return res.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const sendOtpCustomer = async (bodyData) => {
  try {
    const res = await api.sendOtp(bodyData);
    return res.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw error;
    }
  }
};